import { Observable } from 'rxjs';

import { UnitResult } from '../../../error/Domain/unit-result';

/**
 * Abstract base class for API clients.
 *
 * Defines a contract for making HTTP POST requests to backend endpoints.
 * Implementations must provide the `post` method, which takes a request payload and endpoint,
 * and returns an Observable of the typed response. This enables consistent, type-safe API communication
 * and allows for easy mocking or swapping of API implementations in tests or different environments.
 *
 * @template Request - The type of the request payload.
 * @template Response - The type of the expected response.
 */
export abstract class ApiClient {
    abstract post<Request, Response>(
        endpoint: string,
        data: Request,
        displayErrors: boolean
    ): Observable<UnitResult<Response>>;

    abstract get<Response>(
        endpoint: string,
        displayErrors: boolean,
        params?: { [key: string]: string | number | boolean }
    ): Observable<UnitResult<Response>>;

    abstract put<Request, Response>(
        endpoint: string,
        data: Request,
        displayErrors: boolean
    ): Observable<UnitResult<Response>>;

    abstract patch<Request>(endpoint: string, data: Request, displayErrors: boolean): Observable<UnitResult<null>>;
}
